import { render, staticRenderFns } from "./order-more.vue?vue&type=template&id=76015b0a&scoped=true&"
import script from "./order-more.vue?vue&type=script&lang=js&"
export * from "./order-more.vue?vue&type=script&lang=js&"
import style0 from "./order-more.vue?vue&type=style&index=0&id=76015b0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76015b0a",
  null
  
)

export default component.exports